import { Tag, Spinner } from "@blueprintjs/core";
import React from "react";
import { apiCallPost } from "../fns/util";
import { inject, observer } from "mobx-react";

class ItemInventoryLocationWidget extends React.Component {
  state = {
    isLoading: false,
    notValid: false,
    loadedQty: 0,
  };
  componentDidMount() {
    if (!this.props.location) {
      this.setState({ notValid: true });
    }
    if (!this.props.itemId) {
      this.setState({ notValid: true });
    }
    this.getDetails();
  }
  getDetails = async () => {
    try {
      this.setState({ isLoading: true });
      let res = await apiCallPost(
        `/ims2/${this.props.authStore.prefix}/inventory/stock`,
        {
          itemId: this.props.itemId,
          location: this.props.location,
        }
      );
      if (!res || !res.length) {
        this.setState({ isLoading: false, notValid: false, loadedQty: 0 });
        return;
      }
      let total = 0;
      for (var i = 0; i < res.length; i++) {
        total += Math.floor(res[i].quantity / res[i].subunitOfConsumption);
      }
      this.setState({ isLoading: false, notValid: false, loadedQty: total });
    } catch (err) {
      this.setState({ isLoading: false, notValid: true });
    }
  };

  render() {
    if (this.state.notValid) return null;
    if (this.state.isLoading) return <Spinner size={20} />;
    return (
      <Tag large minimal>
        In Inventory: {this.state.loadedQty} {this.props.itemUnitName}
      </Tag>
    );
  }
}

export default inject("authStore")(observer(ItemInventoryLocationWidget));
